import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "box-panel"
};
const _hoisted_2 = {
    class: "external-input"
};
const _hoisted_3 = {
    class: "input-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_input = _resolveComponent("el-input");
    return _openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[2] || (_cache[2] = _createElementVNode("div", {
                class: "cont"
            }, "外部链接", -1)),
            _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_input, {
                    modelValue: $data.externalUrl,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.externalUrl = $event),
                    placeholder: "请输入完整的外部链接，如：https://www.example.com",
                    clearable: "",
                    onInput: $options.onChange
                }, null, 8, [
                    "modelValue",
                    "onInput"
                ]),
                _cache[1] || (_cache[1] = _createElementVNode("div", {
                    class: "tip"
                }, "请输入完整的 URL 地址，包含 http:// 或 https://", -1))
            ])
        ])
    ]);
}
